module.exports = "/images/escape room.svg?d0038a95216786562d4187fc89bdc37e";